import React, { FunctionComponent, useMemo } from 'react';
import { meetingTasksPageSelectors } from '../../../../../../../../app/page/page-storage/meeting-tasks/meeting-tasks.selectors';

import { taskSimpleSelectors } from '../../../../../../../../app/resource/task-simple/task-simple.selectors';
import { ITaskSimple } from '../../../../../../../../app/resource/task-simple/task-simple.types';
import { ITask } from '../../../../../../../../app/resource/task/task.types';
import { useSelect, useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { useToggler } from '../../../../../../../../utils/toggler.utils';
import { TaskCalendar } from '../../../../../widget-items/task-widget-items/TaskCalendar';
import { ICalendarItemDayProps } from './types';

export const CalendarItemDay: FunctionComponent<ICalendarItemDayProps> = ({ meetingId, date, userFilter }) => {
  // const boardList = useSelectWithParams(
  //   boardListSelectors.selectResourceById,
  //   generateBoardListId(meetingId, 'groupNonDefaultByDate', { date }),
  // );

  // const boardTasks = useSelectWithParams(taskSelectors.selectResourcesById, boardList ? boardList.tasksIds : []);

  // const qiList = useSelectWithParams(
  //   boardListSelectors.selectResourceById,
  //   generateBoardListId(meetingId, 'groupQIsByDate', {
  //     taskTypeId: '1',
  //     date: date,
  //   }),
  // );

  // const qiTasks = useSelectWithParams(taskSelectors.selectResourcesById, qiList ? qiList.tasksIds : []);

  const [isToggledPanel, handleTogglePanel] = useToggler();

  const meetingTasks = useSelect(meetingTasksPageSelectors.selectMeetingTasks);
  const taskIds: ITaskSimple['id'][] = [];
  if (!!meetingTasks[meetingId]) {
    Object.keys(meetingTasks[meetingId].calendarTasks).forEach((key) => {
      const date1 = new Date(key);
      const date2 = new Date(date);
      // the date should be exactly the same to display it in the day box
      if (date1.getTime() === date2.getTime()) {
        taskIds.push(...meetingTasks[meetingId].calendarTasks[key].active);
        taskIds.push(...meetingTasks[meetingId].calendarTasks[key].done);
      }
    });
  }

  const tasksFull = useSelectWithParams(taskSimpleSelectors.selectResourcesById, taskIds) as ITaskSimple[];

  const tasks = useMemo(
    () =>
      tasksFull.filter((task) => {
        let shouldFilter = false;
        if (task) {
          if (task.taskTypeId === '1') {
            // goal
            shouldFilter = userFilter.includes(task.userId);
          } else {
            shouldFilter =
              task.members.map((id) => userFilter.includes(String(id))).filter((contains) => !!contains).length > 0;
          }
        }
        return shouldFilter;
      }) as ITaskSimple[],
    [tasksFull, userFilter],
  );

  const [firstTask, otherTasks] = useMemo<[undefined | ITaskSimple, ITaskSimple[]]>(() => {
    if (tasks[0]) {
      return [tasks[0], tasks.slice(1, tasks.length)];
    }
    return [undefined, []];
  }, [tasks]);

  return firstTask ? (
    <>
      <TaskCalendar taskId={tasks[0].id} />

      {!!otherTasks.length && (
        <>
          <div className={`more-calendar-items ${!isToggledPanel ? 'opened' : ''}`}>
            {otherTasks.map((task) => (
              <TaskCalendar key={task.id} taskId={task.id} />
            ))}
            <button className="btn btn-sm red-bg f-1 mx-0 my-1 jcc hide_more_events w100" onClick={handleTogglePanel}>
              CLOSE
            </button>
          </div>
          <button
            className="btn btn-sm f-1 mx-0 my-1 jcc show_more_events w100"
            onClick={handleTogglePanel}
          >{`+${otherTasks.length} MORE`}</button>
        </>
      )}
    </>
  ) : (
    <></>
  );
};
